import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import styles from "./categories-preview.module.scss";
import categoryDefault from "@/assets/category.svg";
import { LayoutStyleTypes } from "@/util-react/layout";
import { Gtag } from "@/services/gtag.ts";

export type Category = {
  id: string;
  key: string;
  name: string;
  image: string | null;
  url: string;
  level: string | null;
};

export interface CategoriesPreviewCustomProps {
  type?: LayoutStyleTypes.TYPE_LG | LayoutStyleTypes.TYPE_SM;
  categories?: Category[];
  linkOnly?: boolean;
}

export const CategoriesPreviewCustom: React.FC<CategoriesPreviewCustomProps> = ({ type = LayoutStyleTypes.TYPE_LG, categories = [], linkOnly = false }) => {
  const { t, i18n } = useTranslation();

  const onTabClick = useCallback(
    (index: number) => {
      if (categories[index].level) {
        Gtag.pushEvent("sub_category_click", categories[index].name);
      } else {
        Gtag.pushEvent("top_category_click", categories[index].name);
      }
    },
    [categories],
  );

  // SSR-safe: не используем window/document

  return (
    <div className={[styles.itemList, type === LayoutStyleTypes.TYPE_SM && styles.sm].join(" ")}>
      {categories.map((item, index) => (
        <a className={styles.item} href={item.url} onClick={(e) => onTabClick(index)} draggable={false} key={item.id}>
          <div className={styles.itemInner}>
            <div className={styles.itemIcon}>
              <img src={item.image ?? categoryDefault} alt={`${t("u3ptme5hf70eeh05.category", "Category")} ${item.name}`} />
            </div>
            <div className={styles.itemText}>{item.name}</div>
          </div>
        </a>
      ))}
    </div>
  );
};
